var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('staff-list',_vm._g(_vm._b({attrs:{"staffs":_vm.visibleStaffs,"show-all-filter":_vm.filteredStaffs.length > 0,"page-size":_vm.pageSize,"total":_vm.total}},'staff-list',_vm.$attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }